import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FileResolutionData } from '../../../models/uploaded-image-resolution.model';

@Injectable({ providedIn: 'root' })
export class PixelCalculatorService {
  private workers: Worker[] = [];
  private chunks: File[][] = [];
  private _filProcessed$ = new BehaviorSubject<FileResolutionData>(
    this.getEmptyFileResolutionData(),
  );
  fileProcessed$ = this._filProcessed$.asObservable();

  calculate(files: File[]) {
    if (!files.length) {
      return;
    }
    this.createWorkers();
    this.createFileChunks(files);
    this.dispatchChunksToWorkers();
  }

  reset() {
    this.workers.forEach((worker) => worker.terminate());
    this.workers = [];
    this.chunks = [];
    this._filProcessed$.next(this.getEmptyFileResolutionData());
  }

  private createWorkers() {
    // Use half of the available CPU cores. Using more might overburden the system,
    // but using less will make user wait longer for the results.
    for (let i = 0; i < window.navigator.hardwareConcurrency / 2; i++) {
      this.workers.push(new Worker(new URL('./pixel-calculator.worker', import.meta.url)));
    }
  }

  private createFileChunks(files: File[]) {
    const chunkSize = Math.ceil(files.length / this.workers.length);
    for (let i = 0; i < this.workers.length; i++) {
      this.chunks.push(files.slice(i * chunkSize, (i + 1) * chunkSize));
    }
  }

  private dispatchChunksToWorkers() {
    for (let i = 0; i < this.workers.length; i++) {
      this.workers[i].onmessage = ({ data }) => {
        this._filProcessed$.next(data);
      };
      this.workers[i].postMessage(this.chunks[i]);
    }
  }

  private getEmptyFileResolutionData(): FileResolutionData {
    return {
      name: '',
      width: 0,
      height: 0,
      processed: false,
    };
  }
}
